
<div class="container-fluid">
  <div class="card p-2 mt-4 position-relative">

    <!-- Edit Button -->
    <button class="edit-btn "  [class.editing]="editMode" (click)="toggleEdit()" permission="Education SOP" [permissionTypes]="[PermissionType.EDIT]">
      <i class="fa"></i>
      {{ editMode ? ' Save' : ' Edit' }}
    </button>

    <!-- Toolbar -->
    <div class="toolbar" *ngIf="editMode">
      <div class="toolbar-group">
        <!-- Text Formatting -->
        <button class="toolbar-btn" (click)="executeCommand('bold')" title="Bold">
          <strong>B</strong>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('italic')" title="Italic">
          <em>I</em>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('underline')" title="Underline">
          <u>U</u>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Font Size -->
        <select class="toolbar-select" (change)="executeCommand('fontSize', $any($event.target).value)">
          <option value="">Font Size</option>
          <option value="1">Small</option>
          <option value="3">Normal</option>
          <option value="5">Large</option>
          <option value="7">X-Large</option>
        </select>

        <!-- Font Color -->
        <input
          type="color"
          class="toolbar-color"
          (change)="executeCommand('foreColor', $any($event.target).value)"
          title="Text Color"
        />

        <div class="toolbar-divider"></div>

        <!-- Alignment -->
        <button class="toolbar-btn" (click)="executeCommand('justifyLeft')" title="Align Left">
          <i class="fa fa-align-left"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('justifyCenter')" title="Align Center">
          <i class="fa fa-align-center"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('justifyRight')" title="Align Right">
          <i class="fa fa-align-right"></i>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Lists -->
        <button class="toolbar-btn" (click)="executeCommand('insertUnorderedList')" title="Bullet List">
          <i class="fa fa-list-ul"></i>
        </button>
        <button class="toolbar-btn" (click)="executeCommand('insertOrderedList')" title="Numbered List">
          <i class="fa fa-list-ol"></i>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Table Operations -->
        <button class="toolbar-btn" (click)="insertTable()" title="Insert Table">
          <i class="fa fa-table"></i> Table
        </button>
        <button class="toolbar-btn" (click)="addTableRow()" title="Add Row">
          <i class="fa fa-plus"></i> Row
        </button>
        <button class="toolbar-btn" (click)="addTableColumn()" title="Add Column">
          <i class="fa fa-plus"></i> Col
        </button>


        <button class="toolbar-btn" (click)="deleteTableRow()" title="Delete Row">
          <i class="fa fa-minus"></i> Row
        </button>

        <button class="toolbar-btn" (click)="deleteTableColumn()" title="Delete Column">
          <i class="fa fa-minus"></i> Col
        </button>
        <button class="toolbar-btn" (click)="deleteTable()" title="Delete Table">
          <i class="fa fa-trash"></i> Table
        </button>

        <button class="toolbar-btn" (click)="insertLink()" title="Insert Link">
          <i class="fa fa-link"></i>
        </button>

      </div>
    </div>

    <!-- Content Area -->
    <div
      #contentArea
      [contentEditable]="editMode"
      class="editable-wrapper"
      [class.editing-mode]="editMode"
    >

      <!-- Header Container -->
<!--      <div class="header-container">-->
<!--        <div class="sop-header">-->
<!--          <h1 class="sop-title">Non-Formal Educational Intervention – SOP</h1>-->
<!--          <img-->
<!--            [src]="logoSrc"-->
<!--            class="sop-logo"-->
<!--            [class.editable-logo]="editMode"-->
<!--            (click)="changeLogo()"-->
<!--            [title]="editMode ? 'Click to change logo' : ''"-->
<!--            alt="logo"-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->

      <div class="header-container">
        <div class="sop-header">

          <h1 class="sop-title"
              [contentEditable]="editMode"
              (input)="onTitleChange($event)">
            {{ sopTitle }}
          </h1>

          <img
            [src]="logoSrc"
            class="sop-logo"
            [class.editable-logo]="editMode"
            [style.pointer-events]="editMode ? 'auto' : 'none'"
            (click)="changeLogo()"
          />

        </div>
      </div>


      <h3 class="intro">Introduction : </h3>
      <p class="text fs-6">
        Non-Formal Education Intervention at Accesslife Assistance Foundation was initiated to bridge the gap and help
        children be in touch with their education. So that after successfully completing their treatment children can have
        a co-relation with their ongoing studies despite the lapse during treatment. The baseline assessment, intermediate
        assessment, discharge assessment, and IEP goals are being planned and implemented by our teachers.
      </p>
      <p class="fs-6">
        The bifurcation of the students is based on their ages. The children who fall under our Non-Formal Education
        Intervention are from the age group of 4 to 14.
      </p>

      <p class="fs-6">
        Children between 4 to 6 years old or in exceptional cases may be accompanied by their parents/caregivers for
        initial 3 to 4 sessions.
      </p>
      <p class="fs-6">
        Toddlers are catered to by our volunteers under the supervision of Accesslife Teachers. Volunteers help in
        developing the gross-motor and fine-motor skills of these toddlers.
      </p>

      <hr>

      <div class="container-fluid my-4 mb-3">

        <!-- Title -->
        <h3 class="fw-bold text-decoration-underline mb-4 fs-3">Annex 1 : Procedure</h3>

        <!-- 1. Pre-Baseline Activity -->
        <div class="mb-4">
          <h5 class="fw-bold fs-6">1. Pre-Baseline Activity</h5>
          <ul class="fs-6">
            <li>
              Read the <strong>Case Analysis of the New Child</strong> to understand the background of the child.
            </li>
            <li>
              Watch the <strong>Admission video of the child</strong> if available to observe the body language
              of the child and the family.
            </li>
          </ul>
        </div>

        <!-- 2. Rapport Building Sessions -->
        <div class="mb-4">
          <h5 class="fw-bold fs-6">2. Rapport Building sessions</h5>
          <ul class="fs-6">
            <li>Conduct rapport-building sessions after 2 days and within 5 days after admission.</li>
            <li>Conduct 1 session of half an hour to 1 hour depending on the child.</li>
          </ul>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
          <table class="table table-bordered black-border">
            <tbody>
            <tr>
              <td class="fs-6"><strong>Introduction and Ice-Breaking Session</strong></td>
              <td>

                <ol class="m-0 fs-6">
                  <li>1.Self-introduction of the teacher.</li>
                  <li>2.Brief idea of how the AL education program works.</li>
                  <li>3.Briefing about the number of sessions.</li>
                  <li>4.Briefing about different Worksheets.</li>
                  <li>5.Enquire about the educational background/level of the child..</li>
                  <li>6.Medium of instruction.</li>
                  <li>7.Finding out hobbies/interests/talents of the child.</li>
                  <li>8.Arrangement of school material by the parents.</li>
                </ol>
                <h4 class="font-bold fs-6">A list of Do's and Don'ts to be informed to the parents.</h4>

                <p class="fs-6">Following activities can be conducted by <br>
                  the Teacher to connect with the child. <br>
                  <span class="font-bold"> Any activity from the following list can <br>
              be conducted: </span></p>

                <ol class="fs-6">
                  <li>1. Art & Craft activity</li>
                  <li>2. A chat session</li>
                  <li>3. Any puzzle game</li>
                  <li>4. Word game</li>
                  <li>5. Audio Visual activity</li>
                  <li>6. Any Board Game.</li>
                </ol>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">3. Baseline Assessment:</h5>
          <p class="fs-6">A baseline assessment is an analysis to identify the previous knowledge of the student. <br>
            The teacher will be conducting an Individual Baseline Assessment for students falling in the <br>
            below age groups.</p>
          <ul class="fs-6">
            <li>Learning Level 1 - 4 years to 5 years 11 months</li>
            <li>Learning Level 2 - 6 years to 7 years 11 months</li>
            <li>Learning Level 3 - 8 years to 9 years 11 months</li>
            <li>Learning Level 4 - 10 years to 11 years 11 months</li>
            <li>Learning Level 5 - 12 years to 14 years</li>
          </ul>
        </div>

        <h5 class="fw-bold fs-6">Google Drive Link for the baselines</h5>

        <p class="fs-6">Link : Final New Baseline -</p>
        <p class="fs-6">The teacher will pick the appropriate assessment for each of the 3 subjects on the basis of <br>
          age and information given by the families about the child's academic background.</p>

        <table class="table table-bordered score-table">
          <thead>
          <tr>
            <th>Sr.No.</th>
            <th>Scores</th>
            <th>Levels</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td>1.</td>
            <td>71% and above</td>
            <td>Next Level Test</td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Between 51% and 70%</td>
            <td>Same Level</td>
          </tr>
          <tr>
            <td>3.</td>
            <td>50% and below</td>
            <td>Previous Level Test</td>
          </tr>
          </tbody>
        </table>


        <p class="fs-6"> Note: The child can be in different levels for different subjects. The AL teacher has to <br>
          conduct baseline tests and find out the learning levels of each child.</p>

        <p class="fs-6">Individual files have to be maintained for each child showcasing solved baseline test papers,<br>
          intermediate test papers, and discharge test papers.</p>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">4. Individual Education Plan</h5>
          <p class="fs-6">The Individual Education Plan (IEP) is a written plan developed by the Teacher as per the<br>
            child's age and standard. After conducting the baseline test for the child, the teacher will<br>
            understand the Learning Level of the child.</p>

          <table class="table table-bordered iep-table text-center">
            <thead>
            <tr>
              <th rowspan="3">Sr.No.</th>
              <th rowspan="3">Child's<br>Full<br>name</th>
              <th rowspan="3">Centre</th>
              <th rowspan="3">Age</th>
              <th rowspan="3">Date of IEP made<br>(New/Modified)</th>

              <!-- Main Header -->
              <th colspan="6">IEP Levels and Baseline Scores</th>
            </tr>

            <tr>
              <th colspan="2">Language</th>
              <th colspan="2">Math</th>
              <th colspan="2">EVS/GK</th>
            </tr>

            <tr>
              <th>Total Baseline Scores</th>
              <th>IEP level</th>

              <th>Total Baseline Scores</th>
              <th>IEP level</th>

              <th>Total Baseline Scores</th>
              <th>IEP level</th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tbody>
          </table>

          <p class="fs-6">Note: Baseline scores and the child's Learning Levels will be mentioned in the IEP sheet.</p>

        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">5. Regular study sessions.</h5>
          <p class="fs-6">We believe in the play-way technique of teaching as our children are going through tough <br>
            treatment and this technique makes it easier for them to learn the concept without stressing it.</p>


          <p class="fs-6">Al Teacher will conduct regular educational sessions based on baseline test results. We have
            <br>
            selected 3 subjects:</p>

          <ol class="fs-6">
            <li>1- Language includes English ,Hindi ,Marathi, Kannada,Tamil & Gujarathi</li>
            <li>2- Math</li>
            <li>3- EVS/GK includes General Science, History, Geography, and General Knowledge).</li>
          </ol>

          <p class="fs-6">AL Teacher will conduct a minimum of 3 individual study sessions per child per month.</p>
          <p class="fs-6">AL Teachers can conduct 2 educational group sessions in a month.</p>
          <p class="fs-6">Additional and appropriate worksheets to be prepared by the teacher for her students.</p>

          <p class="fs-6">To have a constant ongoing process of education we also involve volunteers as and when <br>
            needed. Lesson plans for the volunteers are prepared and executed by the Accesslife teachers. <br>
            Sessions are conducted physically.</p>

        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">6. Intermediate Assessment</h5>
          <p class="fs-6">Intermediate Assessments are formative assessments taken to check the child's <br>
            understanding of a particular concept or a topic taught to them during the regular sessions.<br>
            A Formative evaluation of 10 marks is conducted which can be taken in the form of orals or <br>
            written or both. This assessment has to be done for all subjects. This process of evaluating <br>
            will be repeated till the child stays in AL. If a child scores 70% and above,the child will be <br>
            taught a new topic.</p>

        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">7. Discharge Assessment</h5>
          <p class="fs-6">A discharge assessment is conducted when the child is informed to be on maintenance or <br>
            having the treatment completed . Discharge Assessment is to evaluate the knowledge gained <br>
            by the child during his/her stay in AL and is not meant to evaluate what the child does not <br>
            know. The teacher comes to know about the discharge of the child by the CMs, CCs, or <br>
            Families. This assessment is based on the concepts taught to the child during his/her tenure <br>
            with Access Life. Final Assessment should be conducted in 2 sessions for all subjects before <br>
            1 week of his discharge from the AL centre or taking the average of intermediate test scores <br>
            for preparing the Report card in exceptional cases.</p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">8. Report Card & File</h5>
          <p class="fs-6">For reference and the impact of Non-Formal Education Intervention, a Report card is given <br>
            during discharge. This report card can serve as a reference to local educational institutions <br>
            associated with the children when they go back to their native place. The file along with the <br>
            report card should be handed over to the family while leaving the centre.</p>

          <p class="fs-6">The grades are given based on the scores obtained during the Final Discharge Assessment.</p>

          <p class="fs-6 mt-5">Following is the table which gives you details about the Grading System.</p>

          <table class="table table-bordered text-center align-middle score-table">
            <thead class="table-light">
            <tr>
              <th>Sr.No.</th>
              <th>Marks Scored</th>
              <th>Grades</th>
              <th>Remarks</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>1.</td>
              <td>81 to 100 marks</td>
              <td>"A"</td>
              <td>Excellent</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>61 to 80 marks</td>
              <td>"B"</td>
              <td>Good</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>41 to 60 marks</td>
              <td>"C"</td>
              <td>Average</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>21 to 40 marks</td>
              <td>"D"</td>
              <td>Remedial</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>0 to 20 marks</td>
              <td>"E"</td>
              <td>Pre-Remedial</td>
            </tr>
            </tbody>
          </table>

          <p class="fs-6">Note: The teacher has to conduct Discharge Assessment only on the topics which are
            thoroughly completed by the child.</p>

        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">9. Graduation Ceremony</h5>
          <p class="fs-6">We host a small ceremony to honor the student's time with us. The child is dressed in a gown
            <br>
            and cap, where they are presented with their personal file and report card. This moment is <br>
            dedicated to appreciating their efforts and academic performance during their stay at Access <br>
            Life.</p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">10. Follow up Assessments</h5>
          <p class="fs-6">To monitor the child's academic progress, school engagement, and extracurricular <br>
            participation through structured follow-up assessments. Teachers conduct follow-up <br>
            assessments with parents during their follow-up visit to the centre. Gather information on <br>
            whether the child is attending school regularly.The usefulness of the Accesslife report card <br>
            provided by the AccessLife (AL) teacher in the school admission process. Additional <br>
            extracurricular activities the child is participating in or learning. Record all collected <br>
            information accurately in MySpace under the Follow up assessment Use the data to evaluate <br>
            progress, plan further and maintain comprehensive records. Follow-up assessments will be <br>
            reviewed periodically to ensure data accuracy and relevance for the child's ongoing <br>
            educational planning.
          </p>


        </div>

        <h3 class="fw-bold text-decoration-underline mb-4 fs-3">Annex 2: Reports & Records Maintained</h3>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">1. Impact Report: Monthly & Quaterly</h5>
          <p class="fs-6">Access Life teachers are responsible for preparing monthly Impact Reports for each centre, <br>
            which includes four comprehensive Quarterly Reports annually.These reports document <br>
            education counts, providing specific information on the sessions and activities conducted <br>
            during the reporting period. Crucially, the Impact Report offers a clear comparison of a <br>
            child's progress from their initial Baseline Assessment through to their Discharge <br>
            Assessment.
          </p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">2. Volunteers Conducting Educational Sessions</h5>
          <p class="fs-6">Volunteers' conducting educational sessions are to be counted in the study session every <br>
            month. The topics will be provided by the AL Teacher in advance. <br>
            From 2 years to 3 years and 11 months – Volunteers will conduct activities to develop their <br>
            Gross Motor skills (Walking, Climbing stairs, throwing a ball, kicking the ball, jumping, <br>
            standing on one foot, and Fine Motor skills ( handling a brush or pen, Paper tearing, using <br>
            scissors, lacing). <br>
            From 4 years to 18 years – Volunteers will conduct Individual & Group Educational sessions.
          </p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">3. Special Day Celebration</h5>
          <p class="fs-6">To organize a meaningful Special Day each month across all centres with active participation
            <br>
            from children and parents.The Special Day is organized to give children a break from regular <br>
            studies and actively engage them in various co-curricular activities. Teachers at accesslife <br>
            plan and brainstorm the theme and activities. They also decide on takeaways for children. <br>
            Teachers encourage maximum participation from children and parents, with support from the <br>
            Centre Coordinator, will capture good and candid photographs & videos, which will be <br>
            shared with the assigned teacher for collation and further sharing for social media posts.
          </p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">4. Maintaining Educational Session Register Centrewise</h5>
          <p class="fs-6">To maintain accurate records of all educational sessions and ensure proper verification and
            accountability.
          </p>

          <p class="fs-6">Record of every educational session in the teaching register, includes:</p>

          <p class="font-bold mb-1" style="font-size: 16px">Child's name</p>
          <p class="font-bold mb-1" style="font-size: 16px">Date of the session</p>
          <p class="font-bold mb-1" style="font-size: 16px">Teachers name and signature</p>
          <p class="font-bold mb-1" style="font-size: 16px">In-time and out-time</p>
          <p class="font-bold mb-1" style="font-size: 16px">Parent's signature</p>
          <p class="font-bold mb-1" style="font-size: 16px">CM's signature</p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">5. Sample Baseline File along with Report card for Visitors</h5>
          <p class="fs-6">To provide visitors and donors with a comprehensive overview of the AccessLife non-formal <br>
            education program across all centres. Prepare a sample file in a booklet format that serves as <br>
            a ready reference for visitors and donors. Include insights into the AccessLife education <br>
            program, its structure, activities, and impact across all centres. Make the sample file readily <br>
            available during centre visits for easy access and reference.
          </p>
        </div>


        <div class="mb-4">
          <h5 class="fw-bold fs-6">6. MYSPACE : Internal Web Application</h5>
          <p class="fs-6">This tool enables the comprehensive capture of data across all our core programs. <br>
            Additionally, it generates Management Information System (MIS) reports, providing valuable <br>
            analysis of our work and its impact on beneficiaries.
          </p>

          <p class="fs-6 font-bold">The following data and reports can be viewed & also be printed</p>

          <p class="fs-6">Data maintained - Education session counts with pictures</p>
          <p class="fs-6">Report card created , saved & printed</p>
          <p class="fs-6">Impact reports created , saved & printed</p>
          <p class="fs-6">Analytical detailed report - over view</p>
          <p class="fs-6">Follow up Assessment</p>
        </div>

        <h3 class="fw-bold text-decoration-underline mb-4 fs-3">Annex 3: New introduction</h3>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">1. Library Corner</h5>
          <p class="fs-6">To promote reading among children and parents through accessible and organized books. Set <br>
            up a library corner in all centres with books sorted by local languages like Hindi ,Marathi, <br>
            Gujarati , Kannada ,Tamil & English along with age appropriate books for children & their <br>
            parents.Teachers may conduct story narration sessions or children/parents may borrow books <br>
            with teacher's knowledge. Record all borrowed books in an Excel sheet, including book <br>
            name, borrower, and borrowing/return dates. Maintain the library corner by regularly <br>
            checking book condition and organization.
          </p>
        </div>

        <div class="mb-4">
          <h5 class="fw-bold fs-6">2. Education Curriculum for Children Above 14 Years</h5>
          <p class="fs-6">To provide personalised learning support for children above 14 years based on their academic
            <br>
            background and interests.Conduct a rapport session with child and parents to understand <br>
            academic history and learning needs. Identify a child's interests in specific subjects or topics <br>
            as these are grown up children who preferably will be having a specific subject & board to be <br>
            followed. If the in-house teacher has adequate knowledge or expertise in the subject, she can <br>
            conduct the session. Source relevant books, materials, or digital resources as required. <br>
            Engage external volunteers if additional support is needed. Develop a flexible learning plan <br>
            tailored to the child's interests. Monitor progress through regular feedback and intermediate <br>
            assessments when necessary.
          </p>
        </div>


        <div class="mb-4">
          <h5 class="fw-bold fs-6">3. Good & Bad Touch - Safety Sessions</h5>
          <p class="fs-6">These crucial safety sessions were planned and executed across all centres.</p>
          <p class="fs-6">The below points are the points to be considered</p>
        </div>

        <div>
          <ul class="fs-6">
            <li>
              <strong>Age Grouping:</strong> Children were divided into two main groups for tailored content:
              <strong>4 to <br> 6 years old</strong> and <strong>7 to 10 years old.</strong>
            </li>

            <li>
              <strong>Gender Specific:</strong> Conducted separately for girls and boys
            </li>

            <li>
              <strong>Content:</strong> The session was delivered using a comprehensive PPT presentation that <br>
              also included a video link for visual demonstration.
            </li>

            <li>
              <strong>Single-Child Protocol:</strong> If a group consisted of only one child, the
              <strong>counselors</strong> <br> handled the session directly.
            </li>
          </ul>

          <p class="fs-6">Parental and Counsellor Follow-Up</p>

          <ul class="fs-6">
            <li>
              For the <strong>younger group</strong> (4–6 years), parents were asked to follow up and
              reinforce the <br> concept.
            </li>

            <li>
              For the <strong>older group</strong> (7–10 years), counselors connected with the children
              individually <br> to ensure understanding and address any concerns.
            </li>
          </ul>
        </div>


      </div>
      <!-- Hidden file input for logo -->
      <input
        #fileInput
        type="file"
        accept="image/*"
        (change)="handleLogoChange($event)"
        style="display: none"
      />
    </div>



  </div>
</div>
